/**
 * Vuex getters for the "group" (org) module.
 *
 * Thin state accessors exposing org data, membership/moderation lists, and
 * group feed posts as-is.
 */
export default {
  getOrgTypes: state => state.orgTypes,
  getOrgData: state => state.orgData,
  getOnlyUserOrgs: state => state.myOrgList,
  getBrowseOrgs: state => state.otherOrgList,
  getSearchMembers: state => state.serchMembers,
  getNumFollowersChannel: state => state.numFollowersChannel,
  getOrgPosts: state => state.orgPosts,
  getOrgLoadStatus: state => state.isLoading,
  getJoinRequests: state => state.joinRequests,
  getNoSearchMembers: state => state.noSearchMembers,
  getNoSearchOrgs: state => state.noSearchOrgs,
  getCurrentOrgProfile: state => state.currentOrgProfile,
  getBannedUsersList: state => state.bannedUsersList,
  getFollowingChannels: state => state.followingChannels,
  getPrivacyPoli: (state) => state.privacyPolicy,   // must exist
  getTermsCond: (state) => state.termsConditions,
};
